import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import {
  INVESTOR_DASHBOARD_URL,
} from "helpers/investorAccess";

function InvestorAccessPage() {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "background.default",
        p: 2,
      }}
    >
      <Paper
        elevation={0}
        variant="outlined"
        sx={{
          width: "100%",
          maxWidth: 560,
          p: { xs: 3, md: 4 },
          borderRadius: 2,
          textAlign: "center",
        }}
      >
        <Stack spacing={2.5} alignItems="center">
          <Typography variant="h4" color="primary" fontWeight={700}>
            Investor Dashboard Access
          </Typography>
          <Typography color="text.secondary">
            Your account has investor access. Please continue to the investor
            dashboard to manage your investments.
          </Typography>
          <Button
            variant="contained"
            size="large"
            endIcon={<OpenInNewIcon />}
            href={INVESTOR_DASHBOARD_URL}
          >
            Access Investor Dashboard
          </Button>
          <Typography variant="body2" color="text.secondary">
            {INVESTOR_DASHBOARD_URL}
          </Typography>
        </Stack>
      </Paper>
    </Box>
  );
}

export default InvestorAccessPage;
